mutation ResendVerificationEmail {
  result: StreamToolsResendVerificationEmail {
    sent
  }
}
